module.exports = __webpack_public_path__ + "img/261.dca49a39.png";